import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';

import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { AuthProvider } from './../../providers/auth/auth';
import { UserData } from './../../providers/local/user-data';
import { IonicAngularProvider } from '../../providers/ionic-angular/ionic-angular';

import * as _ from 'lodash';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

	errorLogin: any = {

	};
	myLoginForm: FormGroup;
	validationMessages = {
	  user: {
		  required: 'Correo requerido.'
	  },
	  password: {
		  required: 'Contraseña requerida.',
		  minlength: 'Mínimo 5 caracteres.',
	  }
	};
  
	sedes: any = [
	  {
		key: 'HMO',
		password: 'HMO123'
	  },
	  {
		key: 'MXL',
		password: 'MXL123'
	  },
	  {
		key: 'MOC',
		password: 'MOC123'
	  },
	  {
		key: 'test',
		password: 'test'
	  }
	];
	showSedesFieldPassword: any = "ALL123";
	showSedesField: any = false;

  constructor(
  	private authWS: AuthProvider, 
  	private userData: UserData,
  	private router: Router,
    private formBuilder: FormBuilder,
	public IA: IonicAngularProvider,
	) { 
	  this.showSedesField = this.userData.showSedeField;
		this.myLoginForm = this.createMyForm();
		console.log(this.myLoginForm);
	}

  ngOnInit() {
  }

  
  

      

  ionViewDidLoad() {
    console.log('ionViewDidLoad LoginPage');
  }

  private createMyForm() {
    return this.formBuilder.group({
        sede: [this.userData.sede, Validators.compose([Validators.required])],
        user: [this.userData.lastUserLogged, Validators.compose([Validators.required])],
        password: ['', Validators.compose([Validators.minLength(3), Validators.required])]
    });
  }

  validateField(fieldSearch: string) {
    let data = [];
    data[fieldSearch] = "";
    if (fieldSearch == "all"){
      data = this.errorLogin;
    }
    for (let field in data) {
      this.errorLogin[field] = '';
      let control = this.myLoginForm.controls[field];
      if (control && !control.valid) {
        this.errorLogin[field] = this.validationMessages[field][Object.keys(control.errors)[0]];
      }
    }
  }

  login() {
    this.IA.showLoading();
    let user = this.myLoginForm.value.user;
    let password = this.myLoginForm.value.password;
    if(user == 'SEDE') {
      this.loginSede(password);
      this.IA.hideLoading();
    } else {
      this.authWS.login(user, password)
      .then((data) => {
        if(data && data.status=='success') {
          this.userData.lastUserLogged = user;
          //alert('Redirect');
          this.router.navigate(['v1']);
          //window.location.href = '/';
        } else if(data && data.message) {
          this.IA.toast(data.message);
        }
        console.log('d', data);
        this.IA.hideLoading();
      });
    }
   
  }

  loginSede(password) {
    if(password == this.showSedesFieldPassword) {
      this.showSedesField = !this.showSedesField;
      this.userData.showSedeField = this.showSedesField;
      return true;
    } else {
      let sede = _.find(this.sedes, { password: password });
      if(sede) {
          this.userData.sede = sede.key;
          this.myLoginForm.controls.sede.setValue(sede.key);
      }
    }
  }

  selectSede() {
    this.userData.sede = this.myLoginForm.value.sede;
    console.log('HELLO')
  }

}



// WEBPACK FOOTER //
// C:/projects/angular/DineroAgil/src/app/pages/login/login.component.ts